import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Card, Link, Typography, Stack, Button, Container, InputAdornment, TextField } from '@mui/material';
import Grid from '@mui/material/Grid'
import { useForm, Controller } from "react-hook-form";
import { showSuccess, showError } from '../../utils/toast';
import { useGetCityQuery, useGetAriaQuery, useGetStateQuery } from '../../redux/services/common/Common';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

// api
import { useGetUpdateSallerApiMutation } from '../../redux/services/seller/seller';



export const SellerInfoUpdate = (props) => {
    const { update, setUpdate, setLoad } = props;
    const [getSellerUpdate, sellerUpdate] = useGetUpdateSallerApiMutation()
    const { data: city } = useGetCityQuery()
    const { data: aria } = useGetAriaQuery(update?.city?.id)
    const { data: state } = useGetStateQuery()

    // console.log("city", city)
    // console.log("aria", aria)



    const { register, handleSubmit, setValue, watch, control, reset, formState: { errors } } = useForm();

    useEffect(() => {
        setValue('gst_no', update?.gst_no);
        console.log('gst_no', update?.gst_no)
        setValue('business_name', update?.business_name);
        setValue('pincode', update?.pincode)
        setValue('area', update?.area?.id);
        setValue('city', update?.city?.id);
        setValue('state', update?.state?.id);
        setValue('address', update?.address);
        setValue('landmark', update?.landmark);
        // eslint-disable-next-line react/prop-types
        setValue('shop', update?.shop);
        setValue('loc_lat', update?.loc_lat);
        setValue('loc_lon', update?.loc_lon);

    }, [update])



    const onSellerUpdate = async (data, event) => {
        event.preventDefault();

        console.log('id', update?.id)
        const body = {
            id: update?.id,
            req: "info",
            business_name: data.business_name,
            gst_no: data.gst_no,
            pincode: data.pincode,
            area: data.area,
            city: data.city,
            state: data.state,
            address: data.address,
            landmark: data.landmark,
            shop: data.shop,
            loc_lat: data.loc_lat,
            loc_lon: data.loc_lon

        }
        try {
            await getSellerUpdate(body)
            setUpdate(null);
            reset()
            setLoad()
        }
        catch (error) {
            console.log("Error fetching data:", error);

        }
    }

    useEffect(() => {
        if (sellerUpdate.isSuccess) {
            showSuccess("Seller Dtail Updated !",)
            sellerUpdate.reset()
        }
        if (sellerUpdate.isError) {
            showError(sellerUpdate.error.data.msg)
            sellerUpdate.reset()

        }
    }, [sellerUpdate,])



    return (
        <>
            <Dialog
                open={update != null}
                onClose={() => { setUpdate(null) }}
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography variant='h4' sx={{ textAlign: "center" }}>Seller Update</Typography>
                    <hr />
                </DialogTitle>
                <DialogContent>

                    <br />
                    <br />
                    <form id="edit-form" onSubmit={handleSubmit(onSellerUpdate)}>
                        <Container maxWidth="md">
                            <Grid container spacing={1} mb={2}>

                                <Grid item xs={12} sm={6} md={6} mb={2}>
                                    <TextField
                                        label="Name"
                                        required
                                        id="outlined-required"
                                        {...register("business_name", { required: 'Enter Name' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} >
                                    <TextField
                                        label="GST_No"
                                        required
                                        id="outlined-required"
                                        {...register("gst_no", { required: 'Enter GST_No' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} >
                                    <TextField
                                        label="Pincode"
                                        required
                                        id="outlined-required"
                                        {...register("pincode", { required: 'Enter Pincode' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} mb={2}>
                                    <FormControl variant="outlined" fullWidth>
                                        <InputLabel id="area-label">Area</InputLabel>
                                        <Select
                                            labelId="area-label"
                                            label="Area"
                                            {...register("area", { required: 'Enter Area' })}
                                            value={watch("area") || (update?.area?.id || '')}
                                            onChange={(e) => setValue("area", e.target.value)}
                                            defaultValue=""
                                        >
                                            {aria && aria?.data?.map((opetion) => <MenuItem key={opetion?.id} value={opetion?.id}>{opetion?.name}</MenuItem>)}

                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6} md={6} >
                                    <FormControl variant="outlined" fullWidth>
                                        <InputLabel id="City-label">City</InputLabel>
                                        <Select
                                            labelId="City-label"
                                            label="City"
                                            {...register("city", { required: 'Enter City' })}
                                            value={watch("city") || (update?.city?.id || '')}
                                            onChange={(e) => setValue("city", e.target.value)}
                                            defaultValue=""
                                        >
                                            {city && city?.data?.map((opetion) => <MenuItem key={opetion?.id} value={opetion?.id}>{opetion?.name}</MenuItem>)}

                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} mb={2} >
                                    <FormControl variant="outlined" fullWidth>
                                        <InputLabel id="State-label">State</InputLabel>
                                        <Select
                                            labelId="State-label"
                                            label="State"
                                            {...register("state", { required: 'Enter State' })}
                                            value={watch("state") || (update?.state?.id || '')}
                                            onChange={(e) => setValue("state", e.target.value)}
                                            defaultValue=""
                                        >
                                            {state && state?.data?.map((opetion) => <MenuItem key={opetion?.id} value={opetion?.id}>{opetion?.name}</MenuItem>)}

                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} >
                                    <TextField
                                        label="Address"
                                        required
                                        id="outlined-required"
                                        {...register("address", { required: 'Enter Address' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} mb={2} >
                                    <TextField
                                        label="Landmark"
                                        required
                                        id="outlined-required"
                                        {...register("landmark", { required: 'Enter Landmark' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} >
                                    <TextField
                                        label="Shop"
                                        required
                                        id="outlined-required"
                                        {...register("shop", { required: 'Enter Shop' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} mb={2} >
                                    <TextField
                                        label="Loc_Lat"
                                        required
                                        id="outlined-required"
                                        {...register("loc_lat", { required: 'Enter Loc_Lat' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} >
                                    <TextField
                                        label="Loc_Lon"
                                        required
                                        id="outlined-required"
                                        {...register("loc_lon", { required: 'Enter Loc_Lon' })}
                                    />
                                </Grid>
                            </Grid>
                        </Container>
                        <DialogActions>
                            <Button type="submit" >
                                Update
                            </Button>
                            <Button onClick={() => { setUpdate() }}>Cancel</Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog >
        </>
    );
}




